// utils/api/FeedbackApi.js
import { apiCall } from './ApiUtils';

export class FeedbackApi {
  /**
   * Get all active users in the current class
   * @param {Object} classContext - Class context with class_id and class_code
   * @returns {Promise} API response with active users
   */
  static async getActiveUsers(classContext) {
    return apiCall('/active-users', { method: 'GET' }, classContext);
  }

  /**
   * Get all feedback entries for a specific user
   * @param {string} username - The username to get feedback for
   * @param {Object} classContext - Class context with class_id and class_code
   * @returns {Promise} API response with feedback entries
   */
  static async getUserFeedback(username, classContext) {
    return apiCall(`/user-feedback/${username}`, { method: 'GET' }, classContext);
  }

  /**
   * Get detailed feedback information for a specific feedback entry
   * @param {string} feedbackId - The feedback entry ID
   * @param {Object} classContext - Class context with class_id and class_code
   * @returns {Promise} API response with detailed feedback information
   */
  static async getFeedbackDetails(feedbackId, classContext) {
    return apiCall(`/feedback-details-new/${feedbackId}`, { method: 'GET' }, classContext);
  }

  /**
   * Submit new feedback entry
   * @param {Object} feedbackData - The feedback data to submit
   * @param {Object} classContext - Class context with class_id and class_code
   * @returns {Promise} API response with submission result
   */
  static async submitFeedback(feedbackData, classContext) {
    return apiCall('/feedback', {
      method: 'POST',
      body: JSON.stringify(feedbackData)
    }, classContext);
  }

  /**
   * Delete a feedback entry
   * @param {string} feedbackId - The feedback entry ID to delete
   * @param {Object} classContext - Class context with class_id and class_code
   * @returns {Promise} API response with deletion result
   */
  static async deleteFeedback(feedbackId, classContext) {
    return apiCall(`/feedback/${feedbackId}`, { method: 'DELETE' }, classContext);
  }
}

export default FeedbackApi;